import isPlainObject from 'lodash/isPlainObject'
import { isObservableArray, isObservableMap } from 'mobx'

export default function getMapValue (map, name = '', defaultValue = null) {
  if (typeof name !== 'string' || name === '' || !name) {
    return defaultValue
  }

  if (!map) {
    return defaultValue
  }

  const nameFragments = name.split(/[\[\]\.]/).filter(function (part) {
    return part !== ''
  })

  const dottedName = nameFragments.join('.')

  let value = null

  if (isObservableMap(map)) {
    if (map.has(dottedName)) {
      value = map.get(dottedName)
      if (value === null || typeof value === 'undefined') {
        value = defaultValue
      }
      return value
    }
  }

  value = nameFragments.reduce((acc, nameFragment) => {
    if (!acc) {
      return null
    }

    if (isPlainObject(acc)) {
      if (typeof acc[nameFragment]) {
        return acc[nameFragment]
      }
      return null
    }

    if (Array.isArray(acc) || isObservableArray(acc)) {
      const nameAsNumber = parseInt(nameFragment)
      if (!isNaN(nameAsNumber)) {
        if (typeof acc[nameAsNumber]) {
          return acc[nameAsNumber]
        }
      }
      return null
    }

    if (isObservableMap(acc)) {
      if (acc.has(nameFragment)) {
        return acc.get(nameFragment)
      }

      // console.log('!!!!! map value missing', acc.entries(), nameFragment)
      return null
    }

    // console.log('!!!!! undefined type', acc)

    return null
  }, map)

  if (value === null || typeof value === 'undefined') {
    value = defaultValue
  }

  return value
}
